import About from "./About";
import Contact from "./Contact";
import Education from "./Education";
import Experience from "./Experience";
import Projects from "./Projects";
import Skills from "./Skills";

const Page = ({refs})=>{
   return (
    <div style={{paddingTop:"60px",justifyContent:"center",display:"flex",flexDirection:"column"}}>
      <About refAbout={refs.refAbout}/>
      <Projects refProjects={refs.refProjects}/>
      <Skills refSkills={refs.refSkills}/>
      <Experience refExperience={refs.refExperience}/>
      <Education refEducation={refs.refEducation}/>
      <Contact refContact={refs.refContact}/>
    </div>
   )
}

export default Page;